import React from 'react';

import { Box } from '@mui/material';

import { useIntelState } from '../../context/IntelState';
import KdGraphs from '../Stats/KdGraphs';
import KdSearch from '../Stats/KdSearch';
import Resources from '../Stats/Resources';

const StatsWrapper: React.FC = () => {
  const { intelState } = useIntelState();
  if (!intelState) return null;
  return (
    <Box
      sx={{
        mt: 2,
        mx: 2
      }}>
      <Resources />
      <KdGraphs />
      <KdSearch />
    </Box>
  );
};

export default StatsWrapper;
